var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtnMas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45.67,
    height: 45.6684,
    rx: 17,
    fill: "#31C2F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.335 22.834C31.335 23.2098 31.1908 23.5731 30.9214 23.8362C30.6582 24.1055 30.2948 24.2559 29.9188 24.2559H24.2542V29.9184C24.2542 30.2942 24.1039 30.6575 23.8344 30.9206C23.5712 31.1837 23.2141 31.334 22.8381 31.334C22.4621 31.334 22.0987 31.1837 21.8355 30.9206C21.5661 30.6575 21.4157 30.2942 21.4157 29.9184V24.2559H15.7511C15.3751 24.2559 15.0117 24.1055 14.7485 23.8362C14.4853 23.5731 14.335 23.2098 14.335 22.834C14.335 22.4582 14.4853 22.1011 14.7485 21.8318C15.0117 21.5687 15.3751 21.4184 15.7511 21.4184H21.4157V15.7559C21.4157 15.38 21.5661 15.0167 21.8355 14.7537C22.0987 14.4843 22.4621 14.334 22.8381 14.334C23.2141 14.334 23.5712 14.4843 23.8344 14.7537C24.1039 15.0167 24.2542 15.38 24.2542 15.7559V21.4184H29.9188C30.2948 21.4184 30.6582 21.5687 30.9214 21.8318C31.1908 22.1011 31.335 22.4582 31.335 22.834Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnMas);
export default __webpack_public_path__ + "static/media/btnMas.87e9dcd7cb16a53ead6cc5f5c1bdda27.svg";
export { ForwardRef as ReactComponent };